module.exports = __webpack_public_path__ + "media/images/next-5539675af06a054e9bee1d7c331c5739.svg";